module.exports = __webpack_public_path__ + "static/media/noOfApplication.a1ee7f2e.svg";